import { createSlice } from "@reduxjs/toolkit";
import { login } from "../../thunks/authThunk";
import { message } from "antd";

// Load persisted user from localStorage (if available)
const persistedUser = JSON.parse(localStorage.getItem("user")) || null;

const initialState = {
  user: persistedUser?.user || null,
  token: persistedUser?.token || null,
  isAuthenticated: !!persistedUser, // Convert to boolean
  isLoading: false,
  error: null,
  user_type: null,
  loginStatus: "idle",
  userId: null,
  userType: persistedUser?.user?.user_type || "basic", // Store user type
};

export const loginSlice = createSlice({
  name: "login",
  initialState,
  reducers: {
    logout: (state) => {
      // Clear localStorage on logout
      localStorage.clear();
      sessionStorage.removeItem("userRole");
      state.user = null;
      state.token = null;
      state.isAuthenticated = false;
      state.loginStatus = "idle";
      state.error = null;
      state.isLoading = false;
      state.userType = "basic";
      state.errorResponse = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(login.pending, (state) => {
        state.isLoading = true;
        state.error = null;
        state.loginStatus = "loading";
      })
      .addCase(login.fulfilled, (state, action) => {
        state.isLoading = false;
        state.loginStatus = "success";

        // Store API response in state

        if (action.payload?.status == 1)
          if (
            action.payload?.user.user_type === "basic" ||
            action.payload?.user.user_type === "owner"
          ) {
            state.user = action.payload.user;
            state.token = action.payload.token;
            state.error = action.payload.message;
            state.userType = action.payload.user?.user_type || "basic";
            state.userId = action.payload.user?.user_id;

            state.isAuthenticated = action.payload.status; // Ensure it reflects correct status
            state.errorResponse = action.payload?.message;
            message.success("Signed In successfully", 5);
            localStorage.setItem("user", JSON.stringify(action.payload));
            sessionStorage.setItem("userRole", action.payload.user.user_type);
          } else {
            message.error("Access denied. Please contact support.", 5);
          }

        // Persist user data in localStorage
      })
      .addCase(login.rejected, (state, action) => {
        state.isLoading = false;
        state.loginStatus = "failed";
        state.error = action.payload || "Login failed";
        message.error("Something went wrong!");
      });
  },
});

export const { logout } = loginSlice.actions;
export default loginSlice.reducer;
